<ion-item button (click)="openDetail.emit(item)">
  <div class="badge-wrapper" slot="start">
    <ng-content></ng-content>
  </div>
  <ion-label class="ion-text-wrap item-label">
    <h3 class="item-label__title">
      <span class="skeleton">{{ item.displayName }}</span>
    </h3>
  </ion-label>
</ion-item>
